import { deferredResourceQueryOptions } from "@/utils/deferred-resource-query";
import { orpc } from "@/utils/orpc.client";

interface CompanyBioResourceQueryOptionsInput {
  companyId: string;
  locale: string;
}

export function getCompanyBioResourceQueryOptions({
  companyId,
  locale,
}: CompanyBioResourceQueryOptionsInput) {
  return deferredResourceQueryOptions(
    orpc.music.getCompanyBioResource.queryOptions({
      input: { companyId, locale },
    }),
  );
}
